<div class="vault-page-shell">
  <div class="vault-page-header">
    <div class="space-y-3">
      <p class="vault-page-kicker">Health systems</p>
      <div class="space-y-2">
        <h1 class="vault-page-title">Connected accounts</h1>
        <p class="vault-page-copy max-w-2xl">Keep track of the health systems currently linked to your vault and manage permissions and sharing with other Applications.</p>
      </div>
    </div>

    <a routerLink="/search" class="vault-primary-button">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M12 5v14M5 12h14"/>
      </svg>
      Add account
    </a>
  </div>
  <div class="vault-divider"></div>

  <section class="vault-panel p-3 sm:p-4" *ngIf="configService.vaultProfileConfigSubject | async as vaultProfile">
    <div *ngIf="loading" class="rounded-2xl border border-slate-200 bg-slate-50 px-6 py-10 text-center">
      <div class="inline-flex items-center gap-3 text-sm font-medium text-slate-600">
        <app-spinner [sizePx]="24" [strokeWidthPx]="3"></app-spinner>
        Loading connected accounts...
      </div>
    </div>

    <div *ngIf="errorMessage && !loading" class="mb-4 rounded-2xl border border-rose-200 bg-rose-50 px-5 py-4 text-sm text-rose-700">
      <p>{{ errorMessage }}</p>
      <button type="button" class="vault-text-button mt-3" (click)="loadConnectedAccounts(true)">Try again</button>
    </div>

    <div class="divide-y divide-slate-100" *ngIf="!loading && (vaultProfile.connectedPatientAccounts || []).length; else emptyState">
      <a
        *ngFor="let account of (vaultProfile.connectedPatientAccounts || [])"
        class="vault-list-row"
        [routerLink]="['/dashboard/accounts', account.org_connection_id]"
        [attr.aria-label]="'View details for ' + (account.portal?.name || account.brand?.name)">
        <div class="flex items-center gap-4">
          <img
            imageFallback
            [src]="'https://cdn.fastenhealth.com/logos/sources/' + account.brand?.id + '.png'"
            [alt]="account.portal?.name || account.brand?.name"
            class="h-12 w-12 rounded-lg border border-slate-200 bg-white object-contain p-2">
          <div class="space-y-1">
            <p class="font-semibold text-slate-900">{{ account.portal?.name || account.brand?.name }}</p>
            <p class="text-sm text-slate-500">
              {{ account.patient_auth_type === 'tefca_direct' ? 'Connected through TEFCA discovery.' : 'Connected and ready to sync records.' }}
            </p>
          </div>
        </div>
        <div class="flex items-center gap-3">
          <span class="vault-status-pill is-active">Active</span>
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-slate-400 transition-colors hover:text-slate-700" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </div>
      </a>
    </div>

    <ng-template #emptyState>
      <div *ngIf="!loading" class="rounded-2xl border border-dashed border-slate-200 bg-slate-50 px-6 py-8 text-center">
        <h2 class="text-lg font-semibold text-slate-900">No connected providers yet</h2>
        <p class="mt-2 text-sm leading-6 text-slate-500">
          Add an account to review the healthcare providers we discovered for you through TEFCA.
        </p>
        <p class="mt-2 text-sm leading-6 text-slate-500" *ngIf="getAvailableProviderCount(vaultProfile) > 0">
          {{ getAvailableProviderCount(vaultProfile) }}
          {{ getAvailableProviderCount(vaultProfile) === 1 ? 'provider is' : 'providers are' }}
          available to connect right now.
        </p>
        <a routerLink="/search" class="vault-primary-button mt-5 inline-flex">
          Add account
        </a>
      </div>
    </ng-template>
  </section>
</div>
